module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAARxJREFUSEvFVu0RwiAMfZlAPRdwK4dwHre0p13AeOGaXgg00PrVXwQCL7y8kBIznwFcARyRfwcieri5RZOZ2S0OAC7EzLfK4eL7LoCcMQiAIp8AjCaKkYh8VNEN9m7xLrYFWBVxizoNvACocKlnZQG0/H4KoNwlzis5SVxK0gHUxpq7eU3Ux8zpXPJcGoBEibUXAAo/K+8IwGMv3aDw+zuA17NGKDWymww79jfI6qeZA9ldkWRGl89VL0Wz7j8NkMl2uoHOWZkqNTqncu2mKFSR0uBl7TetlalN+HMyqoWmjhFAsdEUmg10c6FFldwPEDwNUQ5s76gmedNrat+iVpIjgK5K1m6nr6Z0Q9sBFwFanap33QJ8vel/9bflBVoRPY/JXdsvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/images/qr_icon.png
// module id = 3852
// module chunks = 0